import Modal from './MsgModal';
import { showBaseDrawer, showInfoModal, showMsgModal } from './show';

type ModalType = typeof Modal & {
  show: typeof showMsgModal;
  info: typeof showInfoModal;
  drawer: typeof showBaseDrawer;
};

const MsgModal = Modal as ModalType;

MsgModal.show = showMsgModal;
MsgModal.info = showInfoModal;
MsgModal.drawer = showBaseDrawer;

export default MsgModal;
